var uiCopyToClipboard = {
	copy: "Kopieer \"{value}\" naar klembord",
	successMessage: "Gekopieerd",
	failureMessage: "Kan niet kopiëren"
};
var uiCopyToClipboardTranslationsNl = {
	uiCopyToClipboard: uiCopyToClipboard
};

export { uiCopyToClipboardTranslationsNl as default, uiCopyToClipboard };
